<template>
  <div class="recommended-product-benefit-level-container">
    <p>Recommended benefit level:</p>
    <div class="recommended-product-benefit-levell-container">
      <RecommendedBenefit
        v-for="(benefit, index) in benefits"
        class="benefit"
        :text="benefit"
        :index="index"
        :selectedIndex="hoveredBenefitIndex"
        @handleMouseOver="handleMouseOver"
        @handleMouseLeave="handleMouseLeave"
        @benefitSelected="benefitSelected"
      />
    </div>
  </div>
</template>

<script>
  import RecommendedBenefit from './RecommendedBenefit.vue';
  export default {
    name: 'RecommendedBenefitLevel',
    components: {
      RecommendedBenefit,
    },
    props: {
      initialBenefitToDisplay: {
        type: Number,
        required: false,
        default: 0,
      },
      benefits: {
        type: Array,
        required: true,
        default: [],
      },
    },
    data(props) {
      return {
        imgSrc: null,
        hoveredBenefitIndex: props.initialBenefitToDisplay,
        selectedBenefitIndex: props.initialBenefitToDisplay,
      };
    },
    created() {
      this.handleMouseOver(this.initialBenefitToDisplay);
    },
    watch: {
      initialBenefitToDisplay(newVal) {
        this.hoveredBenefitIndex = newVal;
        this.selectedBenefitIndex = newVal;
        this.handleMouseOver(newVal);
        this.handleMouseLeave(newVal);
      },
    },
    computed: {
      // benefits() {
      //   return ["Standard", "Plus", "Premium"];
      // },
    },
    methods: {
      handleMouseOver(index) {
        this.hoveredBenefitIndex = index;
        this.$emit('benefitToDisplay', this.hoveredBenefitIndex);
      },
      handleMouseLeave() {
        this.hoveredBenefitIndex = this.selectedBenefitIndex;
        this.$emit('benefitToDisplay', this.hoveredBenefitIndex);
      },
      benefitSelected(index) {
        this.selectedBenefitIndex = index;
        this.hoveredBenefitIndex = this.selectedBenefitIndex;
        this.$emit('benefitSelected', this.hoveredBenefitIndex);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .recommended-product-benefit-level-container {
    width: 100%;

    p {
      margin: 0;
      font-size: 14px;
      font-weight: 600;
      line-height: 21px;
      color: #282828;
    }

    .recommended-product-benefit-levell-container {
      margin-top: 16px;
      display: flex;

      .benefit:first-child {
        margin-right: 8px;
      }

      .benefit:last-child {
        margin-left: 8px;
      }
    }
  }
</style>
